import get from 'lodash/get';
export default {
  name: 'TypeMismatchWarning',
  props: {
    item: {
      type: Object,
      required: true
    },
    iconClass: {
      type: String,
      default: 'ml-2'
    }
  },
  computed: {
    hasTypeMismatch() {
      const value = get(this.item, 'value.value');
      const declaredType = get(this.item, 'properties.valueType');

      // No warning for null/undefined values or when no type is declared
      if (value === null || value === undefined || !declaredType) {
        return false;
      }
      const actualType = typeof value;

      // Strict type matching - actual runtime type must match declared type
      // No coercion allowed (e.g., string "123" in number field still warns)
      if (declaredType === 'string' && actualType === 'string' || declaredType === 'number' && actualType === 'number' || declaredType === 'boolean' && actualType === 'boolean' || declaredType === 'json' && actualType === 'object') {
        return false;
      }
      return true;
    },
    tooltipMessage() {
      const value = get(this.item, 'value.value');
      const declaredType = get(this.item, 'properties.valueType');
      const detectedType = this.getDetectedValueType(value);
      return this.$i18n_t('DigitalTwin.DigitalTwin.states.typeMismatchWarning', {
        declaredType: declaredType,
        detectedType: detectedType
      });
    }
  },
  methods: {
    getDetectedValueType(value) {
      if (value === null || value === undefined) {
        return 'null';
      }
      const actualType = typeof value;
      if (actualType === 'boolean') {
        return 'boolean';
      }
      if (actualType === 'number') {
        return 'number';
      }
      if (actualType === 'object') {
        return 'json';
      }
      return 'string';
    }
  }
};